export default __webpack_public_path__ + "images/30cfc80f4fa675362cd796b17bbfd1ba.png";